// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-bar-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  flex-shrink: 0;
  margin-inline-end: 30px;
}
.search-bar-container .search-bar {
  flex: 2;
}
.search-bar-container .environment-filter {
  min-width: 220px;
}
.search-bar-container .environment-filter.active {
  --background: rgba(var(--ion-color-primary-rgb), 0.08);
  --border-color: var(--ion-color-primary);
}
.search-bar-container .environment-filter > ion-icon {
  font-size: 13px;
  color: var(--ion-color-medium);
}
.search-bar-container .environment-filter ion-button {
  margin: 0;
  --padding-start: 4px;
  --padding-end: 4px;
  --color: var(--ion-color-medium-shade);
}
.search-bar-container .environment-filter ion-button ion-icon {
  font-size: 20px;
}
.search-bar-container .environment-filter ion-button:hover {
  --color: var(--ion-color-primary);
}
.search-bar-container .select-box {
  margin-block: 12px;
}
.search-bar-container .select-box ion-select::part(icon) {
  position: absolute;
  right: var(--padding-end);
  padding-inline-end: 16px;
}
.search-bar-container .select-box + .select-box {
  margin-inline-start: 30px;
}
.search-bar-container ion-button {
  height: auto;
  width: auto;
  --padding-top: 5px;
  --padding-bottom: 5px;
  --padding-start: 5px;
  --padding-end: 5px;
}
.search-bar-container ion-button ion-icon {
  font-size: 32px;
}

.select-box {
  flex: 1;
}
.select-box ion-input {
  caret-color: transparent;
}

.text-line {
  font-size: 12px;
  line-height: 1.2;
  color: var(--ion-color-primary-contrast);
}

.type-counter {
  font-size: 8px;
}

.type-counter-displayed {
  line-height: 1.2;
  color: var(--ion-color-primary-contrast);
  font-size: 15px;
}

.text-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: var(--ion-color-primary-contrast);
}

.main-container {
  display: flex;
  padding-top: 10px;
  height: 100%;
}

.button-container {
  flex: 1;
  overflow: auto;
}

.environment-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 40px 16px;
  text-align: center;
  color: var(--ion-color-medium-shade);
}
.environment-empty-state .empty-state-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  margin-block-end: 8px;
  border-radius: 50%;
  background: rgba(var(--ion-color-primary-rgb), 0.1);
  box-shadow: 0 0 0 8px rgba(var(--ion-color-primary-rgb), 0.05);
  color: var(--ion-color-primary);
}
.environment-empty-state .empty-state-icon ion-icon {
  font-size: 30px;
}
.environment-empty-state strong {
  color: var(--ion-text-color);
  word-break: break-word;
}
.environment-empty-state ion-button {
  margin-block-start: 12px;
}

.button-content {
  background-color: #f5f5f5;
  color: #959595;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
  padding-left: 10px;
  padding-right: 10px;
}
.button-content ion-button {
  color: #959595;
}
.button-content ion-button ion-icon {
  font-size: 25px;
}

.colored-box {
  min-height: 45px;
  margin: 10px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  background-color: var(--ion-color-primary);
  gap: 10px;
  color: var(--ion-color-primary-contrast);
  text-transform: uppercase;
}
.colored-box ion-icon[name=chevron-forward-outline] {
  font-size: 25px;
}

.icon-smart-component {
  font-size: 30px;
  color: var(--ion-color-primary-contrast);
}

@media (max-width: 1024px) {
  .text-line {
    font-size: 8px;
  }
  .type-counter-displayed {
    font-size: 10px;
  }
}
.content-box {
  flex: 3;
  padding: 10px;
  border: 1px solid #ccc;
  position: relative;
}

.form-buttons {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.delete-button {
  --background: var(--ion-color-danger-shade);
  color: var(--ion-color-danger-contrast);
}

ion-button {
  font-size: 14px;
}
ion-button > div {
  display: flex;
  align-items: center;
  gap: 10px;
}
ion-button ion-icon {
  font-size: 20px;
}

.button-content {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 1;
}

.active-tab {
  color: var(--ion-color-primary);
}

.inactive-tab {
  color: #959595;
}

.icon-environment {
  color: rgba(0, 0, 0, 0.4);
  font-size: 30px;
}

ion-thumbnail {
  height: 60px;
  width: 60px;
  color: black;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 1;
  background-color: #f0f0f0;
  border-radius: 100px;
}

.center {
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
}

ion-tab-button:hover .ion-icon {
  color: var(--ion-color-primary);
}

ion-tab-button {
  --color: var(--ion-color-medium);
  --color-hover: var(--ion-color-primary);
  --color-selected: var(--ion-color-primary);
}

ion-tab-bar.digital-place ion-tab-button.tab-selected {
  background-color: var(--ion-color-primary-tab-selected);
  border-radius: 30px;
  border: 4px solid #fff;
}

.selected-box {
  opacity: 0.5;
  transition: opacity 0.3s ease;
}

.element-clickable,
::ng-deep ion-input.element-clickable .native-input {
  cursor: pointer;
}

ion-item.select-box {
  --detail-icon-opacity: 0.6;
  --detail-icon-font-size: 12px;
  --background-hover: white;
  --ripple-color: white;
  --border-color: #d3d3d3;
}
ion-item.select-box ion-input {
  --placeholder-opacity: 0.33;
}
ion-item.select-box ion-input ::ng-deep label {
  margin-bottom: 0;
}

.main-tab {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: var(--ion-color-primary);
}
.main-tab ion-label {
  color: var(--label-color, var(--ion-color-primary));
}

.full-width {
  width: 100%;
}

.full-height {
  height: 100%;
}

.list-environment {
  overflow: auto;
  height: calc(100% - 120px);
  padding-inline: 10px;
}
.list-environment ion-grid {
  width: 100%;
  padding-block: 20px;
}
.list-environment > div {
  display: flex;
  gap: 10px;
}

form {
  height: calc(100% - 120px);
  overflow: auto;
}

.icon-select-create {
  font-size: 8vh;
}

ion-col {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
ion-col .clear-icon {
  font-size: 32px;
  color: var(--ion-color-danger-shade);
}

.icon-address {
  position: absolute !important;
  right: 10px;
  cursor: pointer;
  color: var(--ion-color-danger-shade);
  font-size: 24px;
  z-index: 2;
}

.error {
  color: var(--ion-color-medium-shade);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  justify-content: center;
}
.error + form {
  height: auto;
}
.error > ion-icon {
  font-size: 50px;
}
.error .height-form {
  display: flex;
  justify-content: flex-end;
  height: max-content;
  width: 100%;
}

ion-select {
  max-width: 100%;
  min-width: 70px;
}

.keyword-form {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
}
.keyword-form .select-box {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: column;
  margin-right: 0;
  align-self: stretch;
  border-color: rgba(0, 0, 0, 0.13);
  min-height: 65px;
}
.keyword-form > div {
  display: flex;
  gap: 10px;
}
.keyword-form.reversed {
  flex-direction: row-reverse;
}

.section-with-label {
  padding-block-start: 16px;
  width: 100%;
}
.section-with-label.compact {
  padding-block-start: 0;
}
.section-with-label.compact > div > ion-item > div {
  min-height: 0;
}
.section-with-label > ion-label, .section-with-label > p {
  padding-inline-start: 16px;
}
.section-with-label p.info {
  font-size: 14px;
}
.section-with-label > div {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: center;
}
.section-with-label > div.multiple-items {
  margin-block-start: 16px;
}
.section-with-label > div.multiple-items > ion-item {
  border: 1px solid #ccc;
  border-radius: 15px;
  min-width: 250px;
}
.section-with-label > div.multiple-items > ion-item ion-label {
  flex: 0 0 150px !important;
  width: 150px !important;
  min-width: 150px !important;
  font-size: 14px;
}
.section-with-label > div > ion-item {
  min-width: 350px;
}
.section-with-label > div > ion-item ion-label[position=fixed] {
  flex: 0 0 200px !important;
  width: 200px !important;
  min-width: 200px !important;
}
.section-with-label > div > ion-item > div {
  display: flex;
  align-items: center;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 92px;
}
.section-with-label > div > ion-item ion-icon {
  font-size: 24px;
}
.section-with-label > div > ion-item ion-button {
  --padding-top: 5px;
  --padding-bottom: 5px;
  --padding-start: 5px;
  --padding-end: 5px;
}
.section-with-label > div > ion-item .icon-state {
  height: 60px;
  width: 60px;
}
.section-with-label > div > ion-item .icon-state > img {
  max-width: 40px;
  max-height: 40px;
  object-fit: contain;
}

.position-img {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.position-img ion-icon {
  font-size: 40px;
}

ion-radio {
  margin-inline-end: 10px;
}

ion-note {
  display: flex;
  gap: 8px;
  align-items: center;
}
ion-note ion-icon {
  font-size: 16px;
}
ion-note {
  flex-basis: 100%;
}

.input-flex {
  display: flex;
  align-items: center;
  gap: 5px;
}

ion-modal ion-content {
  --padding-start: calc(var(--ion-safe-area-left) + 16px);
  --padding-end: calc(var(--ion-safe-area-right) + 16px);
  --padding-top: 16px;
  --padding-bottom: 16px;
}

ion-modal .preview-toolbar-with-environment {
  --padding-bottom: 0;
}

ion-modal .preview-environment-container {
  padding-inline: calc(var(--ion-safe-area-left) + 16px) calc(var(--ion-safe-area-right) + 16px);
  padding-block-end: 8px;
}

ion-modal .preview-environment-search {
  position: relative;
}

ion-modal .preview-environment > ion-icon {
  font-size: 13px;
  color: var(--ion-color-medium);
}

ion-modal .preview-environment-suggestions {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 20;
  max-height: 300px;
  overflow-y: auto;
  margin: 0;
  padding: var(--ui-gap-xs, 4px) 0;
  border-radius: var(--ui-radius-sm, 8px);
  box-shadow: var(--ui-shadow-2, 0 4px 12px rgba(0, 0, 0, 0.15));
}
ion-modal .preview-environment-suggestions ion-item {
  --min-height: 40px;
}

ion-modal .preview-environment-highlighted {
  --background: var(--ion-color-light);
}

ion-modal .preview-environment-selected {
  --background: var(--selected-background, #dcdcdc);
}

ion-modal ion-button {
  height: 30px;
  width: 30px;
  --padding-start: 0;
  --padding-end: 0;
  flex-shrink: 0;
}
ion-modal ion-button ion-icon {
  color: var(--ion-color-medium-shade);
}`, "",{"version":3,"sources":["webpack://./src/components/shared-components/components/configuration-smart-component/configuration-smart-component.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,uBAAA;AACF;AACE;EACE,OAAA;AACJ;AAEE;EACE,gBAAA;AAAJ;AAEI;EACE,sDAAA;EACA,wCAAA;AAAN;AAGI;EACE,eAAA;EACA,8BAAA;AADN;AAII;EACE,SAAA;EACA,oBAAA;EACA,kBAAA;EACA,sCAAA;AAFN;AAIM;EACE,eAAA;AAFR;AAKM;EACE,iCAAA;AAHR;AAQE;EACE,kBAAA;AANJ;AAQI;EACE,kBAAA;EACA,yBAAA;EACA,wBAAA;AANN;AASI;EACE,yBAAA;AAPN;AAWE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;AATJ;AAWI;EACE,eAAA;AATN;;AAcA;EACE,OAAA;AAXF;AAaE;EACE,wBAAA;AAXJ;;AAeA;EACE,eAAA;EACA,gBAAA;EACA,wCAAA;AAZF;;AAgBA;EACE,cAAA;AAbF;;AAgBA;EACE,gBAAA;EACA,wCAAA;EACA,eAAA;AAbF;;AAgBA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,wCAAA;AAbF;;AAgBA;EACE,aAAA;EACA,iBAAA;EACA,YAAA;AAbF;;AAgBA;EACE,OAAA;EACA,cAAA;AAbF;;AAgBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,kBAAA;EACA,oCAAA;AAbF;AAeE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,mDAAA;EACA,8DAAA;EACA,+BAAA;AAbJ;AAeI;EACE,eAAA;AAbN;AAiBE;EACE,4BAAA;EACA,sBAAA;AAfJ;AAkBE;EACE,wBAAA;AAhBJ;;AAoBA;EACE,yBAAA;EACA,cAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AAjBF;AAmBE;EACE,cAAA;AAjBJ;AAmBI;EACE,eAAA;AAjBN;;AAsBA;EACE,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,0CAAA;EACA,SAAA;EACA,wCAAA;EACA,yBAAA;AAnBF;AAqBE;EACE,eAAA;AAnBJ;;AAuBA;EACE,eAAA;EACA,wCAAA;AApBF;;AAuBA;EACE;IACE,cAAA;EApBF;EAuBA;IACE,eAAA;EArBF;AACF;AAwBA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AAtBF;;AAyBA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AAtBF;;AAyBA;EACE,2CAAA;EACA,uCAAA;AAtBF;;AAyBA;EACE,eAAA;AAtBF;AAwBE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAtBJ;AAyBE;EACE,eAAA;AAvBJ;;AA2BA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,UAAA;AAxBF;;AA2BA;EACE,+BAAA;AAxBF;;AA2BA;EACE,cAAA;AAxBF;;AA2BA;EACE,yBAAA;EACA,eAAA;AAxBF;;AA2BA;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,yBAAA;EACA,oBAAA;AAxBF;;AA2BA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;AAxBF;;AA2BA;EACE,+BAAA;AAxBF;;AA2BA;EACE,gCAAA;EACA,uCAAA;EACA,0CAAA;AAxBF;;AA4BA;EACE,uDAAA;EACA,mBAAA;EACA,sBAAA;AAzBF;;AA4BA;EACE,YAAA;EACA,6BAAA;AAzBF;;AA4BA;;EAEE,eAAA;AAzBF;;AA4BA;EACE,0BAAA;EACA,6BAAA;EACA,yBAAA;EACA,qBAAA;EACA,uBAAA;AAzBF;AA2BE;EACE,2BAAA;AAzBJ;AA2BI;EACE,gBAAA;AAzBN;;AA8BA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,+BAAA;AA3BF;AA6BE;EACE,mDAAA;AA3BJ;;AA+BA;EACE,WAAA;AA5BF;;AA+BA;EACE,YAAA;AA5BF;;AA+BA;EACE,cAAA;EACA,0BAAA;EACA,oBAAA;AA5BF;AA8BE;EACE,WAAA;EACA,mBAAA;AA5BJ;AA+BE;EACE,aAAA;EACA,SAAA;AA7BJ;;AAiCA;EACE,0BAAA;EACA,cAAA;AA9BF;;AAiCA;EACE,cAAA;AA9BF;;AAiCA;EACE,aAAA;EACA,eAAA;EACA,SAAA;AA9BF;AAgCE;EACE,eAAA;EACA,oCAAA;AA9BJ;;AAkCA;EACE,6BAAA;EACA,WAAA;EACA,eAAA;EACA,oCAAA;EAEA,eAAA;EACA,UAAA;AAhCF;;AAmCA;EACE,oCAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,uBAAA;AAhCF;AAkCE;EACE,YAAA;AAhCJ;AAmCE;EACE,eAAA;AAjCJ;AAoCE;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;AAlCJ;;AAsCA;EACE,eAAA;EACA,eAAA;AAnCF;;AAsCA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;AAnCF;AAqCE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,iCAAA;EACA,gBAAA;AAnCJ;AAsCE;EACE,aAAA;EACA,SAAA;AApCJ;AAuCE;EACE,2BAAA;AArCJ;;AAyCA;EACE,yBAAA;EACA,WAAA;AAtCF;AAwCE;EACE,sBAAA;AAtCJ;AAwCI;EACE,aAAA;AAtCN;AA0CE;EAEE,0BAAA;AAzCJ;AA4CE;EACE,eAAA;AA1CJ;AA6CE;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;AA3CJ;AA6CI;EACE,wBAAA;AA3CN;AA6CM;EACE,sBAAA;EACA,mBAAA;EACA,gBAAA;AA3CR;AA6CQ;EACE,0BAAA;EACA,uBAAA;EACA,2BAAA;EACA,eAAA;AA3CV;AAgDI;EACE,gBAAA;AA9CN;AAgDM;EACE,0BAAA;EACA,uBAAA;EACA,2BAAA;AA9CR;AAiDM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AA/CR;AAkDM;EACE,eAAA;AAhDR;AAmDM;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;AAjDR;AAoDM;EACE,YAAA;EACA,WAAA;AAlDR;AAoDQ;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AAlDV;;AAyDA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAtDF;AAwDE;EACE,eAAA;AAtDJ;;AA0DA;EACE,uBAAA;AAvDF;;AA0DA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AAvDF;AAyDE;EACE,eAAA;AAvDJ;AAiDA;EASE,gBAAA;AAvDF;;AA0DA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAvDF;;AA0DA;EACE,uDAAA;EACA,sDAAA;EACA,mBAAA;EACA,sBAAA;AAvDF;;AA0DA;EACE,mBAAA;AAvDF;;AA0DA;EACE,8FAAA;EACA,sBAAA;AAvDF;;AA0DA;EACE,kBAAA;AAvDF;;AA2DE;EACE,eAAA;EACA,8BAAA;AAxDJ;;AA4DA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,SAAA;EACA,gCAAA;EACA,uCAAA;EACA,8DAAA;AAzDF;AA2DE;EACE,kBAAA;AAzDJ;;AA8DA;EACE,oCAAA;AA3DF;;AA+DA;EACE,iDAAA;AA5DF;;AA+DA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AA5DF;AA8DE;EACE,oCAAA;AA5DJ","sourcesContent":[".search-bar-container {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  flex-shrink: 0;\n  margin-inline-end: 30px;\n\n  .search-bar {\n    flex: 2;\n  }\n\n  .environment-filter {\n    min-width: 220px;\n\n    &.active {\n      --background: rgba(var(--ion-color-primary-rgb), 0.08);\n      --border-color: var(--ion-color-primary);\n    }\n\n    &>ion-icon {\n      font-size: 13px;\n      color: var(--ion-color-medium);\n    }\n\n    ion-button {\n      margin: 0;\n      --padding-start: 4px;\n      --padding-end: 4px;\n      --color: var(--ion-color-medium-shade);\n\n      ion-icon {\n        font-size: 20px;\n      }\n\n      &:hover {\n        --color: var(--ion-color-primary);\n      }\n    }\n  }\n\n  .select-box {\n    margin-block: 12px;\n\n    ion-select::part(icon) {\n      position: absolute;\n      right: var(--padding-end);\n      padding-inline-end: 16px;\n    }\n\n    &+.select-box {\n      margin-inline-start: 30px;\n    }\n  }\n\n  ion-button {\n    height: auto;\n    width: auto;\n    --padding-top: 5px;\n    --padding-bottom: 5px;\n    --padding-start: 5px;\n    --padding-end: 5px;\n\n    ion-icon {\n      font-size: 32px;\n    }\n  }\n}\n\n.select-box {\n  flex: 1;\n\n  ion-input {\n    caret-color: transparent;\n  }\n}\n\n.text-line {\n  font-size: 12px;\n  line-height: 1.2;\n  color: var(--ion-color-primary-contrast);\n  ;\n}\n\n.type-counter {\n  font-size: 8px;\n}\n\n.type-counter-displayed {\n  line-height: 1.2;\n  color: var(--ion-color-primary-contrast);\n  font-size: 15px;\n}\n\n.text-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  color: var(--ion-color-primary-contrast);\n}\n\n.main-container {\n  display: flex;\n  padding-top: 10px;\n  height: 100%;\n}\n\n.button-container {\n  flex: 1;\n  overflow: auto;\n}\n\n.environment-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 40px 16px;\n  text-align: center;\n  color: var(--ion-color-medium-shade);\n\n  .empty-state-icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 64px;\n    height: 64px;\n    margin-block-end: 8px;\n    border-radius: 50%;\n    background: rgba(var(--ion-color-primary-rgb), 0.1);\n    box-shadow: 0 0 0 8px rgba(var(--ion-color-primary-rgb), 0.05);\n    color: var(--ion-color-primary);\n\n    ion-icon {\n      font-size: 30px;\n    }\n  }\n\n  strong {\n    color: var(--ion-text-color);\n    word-break: break-word;\n  }\n\n  ion-button {\n    margin-block-start: 12px;\n  }\n}\n\n.button-content {\n  background-color: #f5f5f5;\n  color: #959595;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 5px;\n  padding-left: 10px;\n  padding-right: 10px;\n\n  ion-button {\n    color: #959595;\n\n    ion-icon {\n      font-size: 25px;\n    }\n  }\n}\n\n.colored-box {\n  min-height: 45px;\n  margin: 10px;\n  border-radius: 15px;\n  display: flex;\n  align-items: center;\n  padding: 0 10px;\n  background-color: var(--ion-color-primary);\n  gap: 10px;\n  color: var(--ion-color-primary-contrast);\n  text-transform: uppercase;\n\n  ion-icon[name=\"chevron-forward-outline\"] {\n    font-size: 25px;\n  }\n}\n\n.icon-smart-component {\n  font-size: 30px;\n  color: var(--ion-color-primary-contrast);\n}\n\n@media (max-width: 1024px) {\n  .text-line {\n    font-size: 8px;\n  }\n\n  .type-counter-displayed {\n    font-size: 10px;\n  }\n}\n\n.content-box {\n  flex: 3;\n  padding: 10px;\n  border: 1px solid #ccc;\n  position: relative;\n}\n\n.form-buttons {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n}\n\n.delete-button {\n  --background: var(--ion-color-danger-shade);\n  color: var(--ion-color-danger-contrast);\n}\n\nion-button {\n  font-size: 14px;\n\n  &>div {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n\n  ion-icon {\n    font-size: 20px;\n  }\n}\n\n.button-content {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: relative;\n  z-index: 1;\n}\n\n.active-tab {\n  color: var(--ion-color-primary);\n}\n\n.inactive-tab {\n  color: #959595;\n}\n\n.icon-environment {\n  color: rgba(0, 0, 0, 0.4);\n  font-size: 30px;\n}\n\nion-thumbnail {\n  height: 60px;\n  width: 60px;\n  color: black;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  z-index: 1;\n  background-color: #f0f0f0;\n  border-radius: 100px;\n}\n\n.center {\n  display: flex;\n  flex-direction: row;\n  align-content: center;\n  align-items: center;\n}\n\nion-tab-button:hover .ion-icon {\n  color: var(--ion-color-primary);\n}\n\nion-tab-button {\n  --color: var(--ion-color-medium);\n  --color-hover: var(--ion-color-primary);\n  --color-selected: var(--ion-color-primary);\n}\n\n// Digital Place keeps the highlighted \"pill\" on the selected tab\nion-tab-bar.digital-place ion-tab-button.tab-selected {\n  background-color: var(--ion-color-primary-tab-selected);\n  border-radius: 30px;\n  border: 4px solid #fff;\n}\n\n.selected-box {\n  opacity: 0.5;\n  transition: opacity 0.3s ease;\n}\n\n.element-clickable,\n::ng-deep ion-input.element-clickable .native-input {\n  cursor: pointer;\n}\n\nion-item.select-box {\n  --detail-icon-opacity: 0.6;\n  --detail-icon-font-size: 12px;\n  --background-hover: white;\n  --ripple-color: white;\n  --border-color: #d3d3d3;\n\n  ion-input {\n    --placeholder-opacity: 0.33;\n\n    ::ng-deep label {\n      margin-bottom: 0;\n    }\n  }\n}\n\n.main-tab {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  color: var(--ion-color-primary);\n\n  ion-label {\n    color: var(--label-color, var(--ion-color-primary));\n  }\n}\n\n.full-width {\n  width: 100%;\n}\n\n.full-height {\n  height: 100%;\n}\n\n.list-environment {\n  overflow: auto;\n  height: calc(100% - 120px);\n  padding-inline: 10px;\n\n  ion-grid {\n    width: 100%;\n    padding-block: 20px;\n  }\n\n  &>div {\n    display: flex;\n    gap: 10px;\n  }\n}\n\nform {\n  height: calc(100% - 120px);\n  overflow: auto;\n}\n\n.icon-select-create {\n  font-size: 8vh;\n}\n\nion-col {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n\n  .clear-icon {\n    font-size: 32px;\n    color: var(--ion-color-danger-shade);\n  }\n}\n\n.icon-address {\n  position: absolute !important;\n  right: 10px;\n  cursor: pointer;\n  color: var(--ion-color-danger-shade);\n\n  font-size: 24px;\n  z-index: 2;\n}\n\n.error {\n  color: var(--ion-color-medium-shade);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  justify-content: center;\n\n  &+form {\n    height: auto;\n  }\n\n  &>ion-icon {\n    font-size: 50px;\n  }\n\n  .height-form {\n    display: flex;\n    justify-content: flex-end;\n    height: max-content;\n    width: 100%;\n  }\n}\n\nion-select {\n  max-width: 100%;\n  min-width: 70px;\n}\n\n.keyword-form {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n\n  .select-box {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    flex-direction: column;\n    margin-right: 0;\n    align-self: stretch;\n    border-color: rgba(0, 0, 0, 0.13);\n    min-height: 65px;\n  }\n\n  &>div {\n    display: flex;\n    gap: 10px;\n  }\n\n  &.reversed {\n    flex-direction: row-reverse;\n  }\n}\n\n.section-with-label {\n  padding-block-start: 16px;\n  width: 100%;\n\n  &.compact {\n    padding-block-start: 0;\n\n    &>div>ion-item>div {\n      min-height: 0;\n    }\n  }\n\n  &>ion-label,\n  &>p {\n    padding-inline-start: 16px;\n  }\n\n  p.info {\n    font-size: 14px;\n  }\n\n  &>div {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 20px;\n    align-items: center;\n\n    &.multiple-items {\n      margin-block-start: 16px;\n\n      &>ion-item {\n        border: 1px solid #ccc;\n        border-radius: 15px;\n        min-width: 250px;\n\n        ion-label {\n          flex: 0 0 150px !important;\n          width: 150px !important;\n          min-width: 150px !important;\n          font-size: 14px;\n        }\n      }\n    }\n\n    &>ion-item {\n      min-width: 350px;\n\n      ion-label[position=\"fixed\"] {\n        flex: 0 0 200px !important;\n        width: 200px !important;\n        min-width: 200px !important;\n      }\n\n      &>div {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        align-items: center;\n        width: 100%;\n        min-height: 92px;\n      }\n\n      ion-icon {\n        font-size: 24px;\n      }\n\n      ion-button {\n        --padding-top: 5px;\n        --padding-bottom: 5px;\n        --padding-start: 5px;\n        --padding-end: 5px;\n      }\n\n      .icon-state {\n        height: 60px;\n        width: 60px;\n\n        &>img {\n          max-width: 40px;\n          max-height: 40px;\n          object-fit: contain;\n        }\n      }\n    }\n  }\n}\n\n.position-img {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  ion-icon {\n    font-size: 40px;\n  }\n}\n\nion-radio {\n  margin-inline-end: 10px;\n}\n\nion-note {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n\n  ion-icon {\n    font-size: 16px;\n  }\n\n  flex-basis: 100%;\n}\n\n.input-flex {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\nion-modal ion-content {\n  --padding-start: calc(var(--ion-safe-area-left) + 16px);\n  --padding-end: calc(var(--ion-safe-area-right) + 16px);\n  --padding-top: 16px;\n  --padding-bottom: 16px;\n}\n\nion-modal .preview-toolbar-with-environment {\n  --padding-bottom: 0;\n}\n\nion-modal .preview-environment-container {\n  padding-inline: calc(var(--ion-safe-area-left) + 16px) calc(var(--ion-safe-area-right) + 16px);\n  padding-block-end: 8px;\n}\n\nion-modal .preview-environment-search {\n  position: relative;\n}\n\nion-modal .preview-environment {\n  &>ion-icon {\n    font-size: 13px;\n    color: var(--ion-color-medium);\n  }\n}\n\nion-modal .preview-environment-suggestions {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  z-index: 20;\n  max-height: 300px;\n  overflow-y: auto;\n  margin: 0;\n  padding: var(--ui-gap-xs, 4px) 0;\n  border-radius: var(--ui-radius-sm, 8px);\n  box-shadow: var(--ui-shadow-2, 0 4px 12px rgba(0, 0, 0, 0.15));\n\n  ion-item {\n    --min-height: 40px;\n  }\n}\n\n// Keyboard highlight: lighter than the selection, so the two stay distinguishable\nion-modal .preview-environment-highlighted {\n  --background: var(--ion-color-light);\n}\n\n//Same color as the selected row of the other lists (IE. address popup, environment tree)\nion-modal .preview-environment-selected {\n  --background: var(--selected-background, #dcdcdc);\n}\n\nion-modal ion-button {\n  height: 30px;\n  width: 30px;\n  --padding-start: 0;\n  --padding-end: 0;\n  flex-shrink: 0;\n\n  ion-icon {\n    color: var(--ion-color-medium-shade);\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
